import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {BruteForce} from "../BruteForce";
import {BruteForceGameAssets} from "../BruteForceGameAssets";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BruteForceSound} from "../sound/BruteForceSound";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class BruteForceBonusOutro extends PIXI.Container {

    private _youWonText: PIXI.Text;
    private _spinsPlayedText: PIXI.Text;
    private _spinsPlayedNr: PIXI.Text;
    private _countUp: BasicBitmapCountUp;
    private _fontTextStyle: PIXI.TextStyle;

    constructor() {
        super();
        this.name = "BonusOutroView";
        this.init();
    }


    public hideFSOutro(): gsap.core.Timeline {
        const hideFSOuttroTL: gsap.core.Timeline = gsap.timeline();
        hideFSOuttroTL.add(() => {
            BruteForce.backgroundElements.setMode("NORMAL");
            BruteForce.allreelsView.changeReelSet();
        });

        hideFSOuttroTL.to(this, {alpha: 0, duration: 0.5}, "<");
        hideFSOuttroTL.to([this._spinsPlayedNr, this._youWonText, this._spinsPlayedText], {
            alpha: 0,
            duration: 0.5
        }, "<");
        hideFSOuttroTL.add(BruteForce.transitionShutter.playDoorOpen());
        hideFSOuttroTL.add(() => {
            BruteForceSound.playTrack(BruteForceSound.DOOR_OPEN)
        }, "<")
        // hideFSOuttroTL.add(BruteForce.foregroundElements.setLinesOverlay(0.1, 0.2), "<")
        hideFSOuttroTL.add(() => {
            BruteForceSound.switchMusic({name: BruteForceSound.MAIN_GAME_MUSIC});
            BruteForceSound.playTrack(BruteForceSound.MAIN_GAME_MUSIC_CRUSHED, 0);
            this.visible = false;
            this._countUp.getCountAnimation(0, 0, 0);
            BruteForce.transitionShutter.doorVisibility(false);
            BruteForce.anticipationView.updateXBetState();
        });
        return hideFSOuttroTL;
    }

    public showOutro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalWin: number = BruteForce.model.gameData.accumulatedRoundWin,
            isZeroWin: boolean = (totalWin === 0);
        tl.add(() => {
            BruteForce.transitionShutter.doorVisibility(true)
        }, 0);
        tl.add(BruteForce.transitionShutter.playDoorClose());
        tl.add(() => {
            BruteForceSound.playTrack(BruteForceSound.DOOR_CLOSE);
        }, "<")
        tl.add(() => {
            BruteForceSound.switchMusic({name: BruteForceSound.BUNKER_SCREEN_MUSIC});
            this._youWonText.text = BruteForce.apiPlugin.translations.translate("YOU WON");
            this._spinsPlayedText.text = BruteForce.apiPlugin.translations.translate("SPINS PLAYED");
            this._spinsPlayedNr.text = `${BruteForce.model.gameData.freespinsPlayed}`;
            this._spinsPlayedNr.position.set(360 - this._spinsPlayedNr.width * 0.5, 460);
            this.visible = true;
            this.alpha = 1;
            this._spinsPlayedText.visible = true;
            this._spinsPlayedNr.visible = true;

        }, ">");

        this._youWonText.visible = !BelowStakeWinRestriction.isWinBelowStake();

        tl.to([this._spinsPlayedNr, this._spinsPlayedText, this._youWonText], {duration: 0.1, alpha: 1});
        // tl.add(BruteForce.foregroundElements.setLinesOverlay(0.1, 0), "<");

        if (!isZeroWin) {
            const isWinBelowStake: boolean = BelowStakeWinRestriction.isWinBelowStake();
            const hasCountUp: boolean = !(isWinBelowStake);
            this._countUp.stopAt(0);
            this._countUp.alpha = 0;
            this._countUp.visible = true;

            tl.to(this._countUp, {duration: 0.2, alpha: 1});
            tl.add(this._countUp.getCountAnimation(0, totalWin, hasCountUp ? 1.5 : 0), ">");
            if (hasCountUp) {
                tl.add(() => {
                    BruteForceSound.playTrack(BruteForceSound.WIN_COUNTUP)
                }, "<");
                tl.add(() => {
                    BruteForceSound.stopSound(BruteForceSound.WIN_COUNTUP);
                    BruteForceSound.playTrack(BruteForceSound.WIN_COUNTUP_END);
                });
            }
        }
        tl.add(() => {
            BruteForce.transitionShutter.doorAnimationLoop();
        }, tl.duration());

        return tl;
    }

    private init(): void {

        this._fontTextStyle = new PIXI.TextStyle({
            fill: ['#f2f209', '#ec910d'],
            fillGradientStops: [0.3, 0.7],
            fillGradientType: 0,
            fontFamily: "Helvetica",
            fontWeight: FontWeight.EXTRA_BOLD,
            fontSize: 65,
            stroke: 0x000000,
            strokeThickness: 4,
            lineJoin: "round",
            //letterSpacing: 2,
            dropShadow: true,
            dropShadowAngle: 0,
            dropShadowBlur: 5,
            dropShadowDistance: 2
        });


        this._youWonText = new PIXI.Text("YOU WON", this._fontTextStyle);
        this._youWonText.visible = false;
        this._youWonText.anchor.set(0.5);
        this._youWonText.position.set(360, 220);
        this._youWonText.name = "youwontext";
        this._youWonText.scale.set(1, 1.2);
        this._youWonText.alpha = 0;
        this.addChild(this._youWonText);

        this._spinsPlayedText = new PIXI.Text("", this._fontTextStyle);
        this._spinsPlayedText.visible = false;
        this._spinsPlayedText.anchor.set(0.5);
        this._spinsPlayedText.scale.set(0.6, 0.6);
        this._spinsPlayedText.position.set(360, 430);
        this._spinsPlayedText.name = "spinsPlayedText";
        this._spinsPlayedText.alpha = 0;
        this.addChild(this._spinsPlayedText);

        this._spinsPlayedNr = new PIXI.Text("", this._fontTextStyle);
        this._spinsPlayedNr.scale.set(1.2, 1.2);
        this._spinsPlayedNr.visible = false;
        this._spinsPlayedNr.name = "spinsPlayedNo";
        this._spinsPlayedNr.alpha = 0;
        this.addChild(this._spinsPlayedNr);


        this._countUp = new BasicBitmapCountUp({
            fontName: BruteForceGameAssets.BITMAP_BONUS_OUTRO_FONT,
            fontSize: 18,
            tint: 0xffffff
        }, 500, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 330);
        this._countUp.stopAt(0);
        this._countUp.alpha = 0;
        this._countUp.getCountAnimation(0, 0, 0);
        this._countUp.name = "amountwoncountuptext";
        this.visible = false;
        this.addChild(this._countUp);
    }
}